import React from 'react'; 
import './RadioBox.css'


export function RadioBox (props) {
  const period=props.period 
  return (
    <div className={`radio radio__${props.type}`} >
      <label className={`radio__label colorGrey font20Norm radio__label_${props.type}`} >
        <input type="radio" value={'month' || ''} checked={period ==='month' ? true : false} className='radio__checkbox' onChange={props.onChange}  name='period' id='month' />
        <span className="visible-checkbox item__link"></span>
        Месяц
      </label>
      <label className={`radio__label colorGrey font20Norm radio__label_${props.type}`} >
        <input type="radio" value={'threemonth' || ''} checked={period ==='threemonth' ? true : false} className='radio__checkbox' onChange={props.onChange}  name='period' id='threemonth' />
        <span className="visible-checkbox item__link"></span>
        3 месяца
      </label>
      <label className={`radio__label colorGrey font20Norm radio__label_${props.type}`} >
        <input type="radio" value={'sixmonths' || ''} checked={period ==='sixmonths' ? true : false} className='radio__checkbox' onChange={props.onChange}   name='period' id='sixmonths' />
        <span className="visible-checkbox item__link"></span>
        Полгода
      </label>
      <label className={`radio__label colorGrey font20Norm radio__label_${props.type}`} >
        <input type="radio" value={'year' || ''} checked={period ==='year' ? true : false} className='radio__checkbox' onChange={props.onChange}   name='period' id='year' />
        <span className="visible-checkbox item__link"></span>
        Год
      </label>
      </div>
  )
}
 